import { onError, onSuccess } from '../../pluginEventUtils';

export const PlaidButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<svg height="35" viewBox="0 0 50 45" color="white" xmlns="http://www.w3.org/2000/svg">
    <g fill="#c3cfe9" fill-rule="evenodd">
    <path d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path></g></svg><div>${label}</div>`,
    category: category,
    content: `
    <div data-gjs-type="plaid">
      <button id="link-btn" class="btn btn-primary" disabled>
        Connect with Plaid
      </button>
    </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, events } = config;
  let eventOptions = events.map((event) => ({
    label: event.eventTitle,
    value: `${event.eventName}(event)`,
  }));
  eventOptions = [{ label: '- Select Event - ', value: '' }, ...eventOptions];
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: `<svg height="10" viewBox="0 0 50 45" xmlns="http://www.w3.org/2000/svg">
          <g fill="#c3cfe9" fill-rule="evenodd">
          <path d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path></g></svg>`,
          projectId: projectId,
          traits: [
            { ...onSuccess, options: eventOptions },
            { ...onError, options: eventOptions },
            ...dc.getType('default').model.prototype.defaults.traits,
          ],
          script: function () {
            const projectId = '{[ projectId ]}';
            const onSuccess = '{[ onSuccess ]}';
            const onFail = '{[ onFail ]}';
            let localStorage = window.localStorage;
            const plaidBtn = document.getElementById('link-btn');
            const accessToken = localStorage.getItem('token');
            console.log('accessToken', accessToken);
            if (!accessToken || accessToken == 'null') {
              plaidBtn.innerHTML = 'User is not Logged In';
            } else {
              const header = {
                headers: {
                  'Content-Type': 'application/json',
                  'x-project-id': projectId,
                  authorization: accessToken,
                },
              };
              const serverUrl = getBackendServerUrl();
              if (serverUrl && serverUrl.length > 0) {
                axios
                  .post(`${serverUrl}plaid/create-link-token`, {}, header)
                  .then((response) => {
                    const data = response.data;
                    localStorage.setItem('link_token', data.link_token);
                    if (data.link_token) {
                      processRequest(data.link_token, header, onSuccess, onFail);
                    }
                  })
                  .catch((error) => {
                    console.log('error', error);
                    if (error.response) {
                      if (error.response.status == 403) {
                        plaidBtn.innerHTML = 'Please login to connect Plaid';
                      }
                    } else if (error.request) {
                      console.log(error.request);
                    } else {
                      console.log('Error', error.message);
                    }
                  });
              }
            }

            const processRequest = (link_token, header, onSuccess, onFail) => {
              console.log('link_token', link_token);
              let sessionStorage = window.sessionStorage;
              try {
                const handler = Plaid.create({
                  token: link_token,
                  onSuccess: function (public_token, metadata) {
                    const serverUrl = getBackendServerUrl();
                    console.log('metadata', metadata);
                    const { account_id } = metadata;
                    axios
                      .post(
                        `${serverUrl}plaid/set-access-token`,
                        { public_token, account_id },
                        header,
                      )
                      .then((response) => {
                        console.log('Successfullt Connected to Plaid');
                        sessionStorage.setItem('PLAID_CONNECTED', 'SUCCESS');
                        setTimeout(onSuccess, 300);
                      })
                      .catch((err) => console.log('err :>> ', err));
                  },
                  onExit: function (error) {
                    if (error) {
                      const { display_message } = error;
                      console.log('display_message :>> ', display_message);
                      sessionStorage.setItem('PLAID_CONNECTED', 'FAILED');
                      eval(onFail);
                    }
                  },
                });
                plaidBtn.disabled = false;
                plaidBtn.onclick = function (e) {
                  if (handler != null) {
                    handler.open();
                  }
                };
              } catch (error) {
                console.log('Plaid redirect error');
              }
            };
          },
        },
        init() {
          const onSuccess = this.get('onSuccess');
          const onFail = this.get('onFail');
          this.on('change:onSuccess', this.handleOnSuccessChange);
          this.on('change:onFail', this.handleOnFailChange);
        },
        handleOnSuccessChange() {
          const onSuccess = this.get('onSuccess');
          let attrs = this.getAttributes();
          attrs = { ...attrs, onSuccess };
          this.setAttributes(attrs);
        },
        handleOnFailChange() {
          const onFail = this.get('onFail');
          let attrs = this.getAttributes();
          attrs = { ...attrs, onFail };
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:onSuccess', this.updateScript);
        this.listenTo(model, 'change:onFail', this.updateScript);
      },
    }),
  });
};
